import Api from "./baseApi";

export default {
  searchMpDiscount: mpDiscount => {
    let url = "/api/mpdiscounts?v=1";
    if (mpDiscount.search) url += `&q=${mpDiscount.search}`;
    if (mpDiscount.onSale !== null && mpDiscount.onSale !== undefined) url += `&onSale=${mpDiscount.onSale}`;
    return Api.get(url);
  },
  getMpDiscounts: () => Api.get("/api/mpdiscounts"),
  getMpDiscount: id => Api.get(`/api/mpdiscounts/${id}`),
  putMpDiscount: mpDiscount => Api.put(`/api/mpdiscounts/${mpDiscount.id}`, mpDiscount),
  deleteMpDiscount: mpDiscount => Api.delete(`/api/mpdiscounts/${mpDiscount.id}`, mpDiscount),
  postMpDiscount: mpDiscount => Api.post(`/api/mpdiscounts`, mpDiscount),
  
  getMissingDiscounts: () => Api.get("/api/mpdiscounts/missing-discounts"),
  syncFromMainDiscounts: discountIds => Api.post("/api/mpdiscounts/sync-from-main", discountIds),
  getMpDiscountsByMarketplace: () => Api.get("/api/mpdiscounts/by-marketplace"),
  getActiveDiscounts: () => Api.get("/api/mpdiscounts/active-discounts")
};
